/* FÉNIX 2.4 V23 HOME HEAD 01 · nm-fenix-21-cinematic-commerce-c02.js */
(function(){'use strict';
function init(){var home=document.querySelector('[data-fnx-c02-home]');if(!home||home.dataset.c02Ready==='1')return;home.dataset.c02Ready='1';
  document.querySelectorAll('[data-fnx-c02-assistant]').forEach(function(btn){btn.addEventListener('click',function(){var fab=document.getElementById('nmChatFab');if(fab){fab.click();return}if(typeof window.toggleChat==='function')window.toggleChat();});});
  var links=home.querySelectorAll('.fnx-c02-selector__list a');links.forEach(function(a){['mouseenter','focus'].forEach(function(evt){a.addEventListener(evt,function(){links.forEach(function(x){x.classList.remove('is-active')});a.classList.add('is-active');},{passive:evt==='mouseenter'});});});
  var hero=home.querySelector('.fnx-c02-hero');var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;var fine=window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if(hero&&!reduce&&fine){var tx=0,ty=0,cx=0,cy=0,raf=0;function paint(){raf=0;cx+=(tx-cx)*.09;cy+=(ty-cy)*.09;hero.style.setProperty('--c02-x',cx.toFixed(2));hero.style.setProperty('--c02-y',cy.toFixed(2));if(Math.abs(tx-cx)>.04||Math.abs(ty-cy)>.04)raf=requestAnimationFrame(paint)}hero.addEventListener('pointermove',function(e){var r=hero.getBoundingClientRect();tx=((e.clientX-r.left)/r.width-.5)*22;ty=((e.clientY-r.top)/r.height-.5)*14;if(!raf)raf=requestAnimationFrame(paint)},{passive:true});hero.addEventListener('pointerleave',function(){tx=ty=0;if(!raf)raf=requestAnimationFrame(paint)},{passive:true});}
  home.classList.add('fnx-c02-js');
  requestAnimationFrame(function(){home.classList.add('is-c02-loaded');});
  var reveals=[].slice.call(home.querySelectorAll('.fnx-c02-signal-deck__rail,.fnx-c02-sectionhead,.fnx-c02-products,.fnx-c02-trust__grid'));
  if(reduce||!('IntersectionObserver' in window)){
    reveals.forEach(function(element){element.classList.add('is-c02-visible');});
  }else{
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        entry.target.classList.add('is-c02-visible');
        observer.unobserve(entry.target);
      });
    },{rootMargin:'0px 0px -10% 0px',threshold:.14});
    reveals.forEach(function(element){observer.observe(element);});
  }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
;

/* FÉNIX 2.4 V23 HOME HEAD 02 · nm-fenix-r07-global-motion-v09.js */
/* FÉNIX R07 v09 · continuous cursor/scroll light. */
(function(){'use strict';
  if(window.__NMR07MotionV09)return;window.__NMR07MotionV09=true;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine=window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if(reduce||!fine)return;
  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn();}
  ready(function(){
    var html=document.documentElement;html.classList.add('nm-r07-motion-ready');
    var light=document.createElement('div');light.className='nm-r07-global-light';light.setAttribute('aria-hidden','true');document.body.appendChild(light);
    var raf=0,scrollTimer=0;
    window.addEventListener('pointermove',function(e){if(raf)cancelAnimationFrame(raf);raf=requestAnimationFrame(function(){html.style.setProperty('--nm-r07-x',e.clientX+'px');html.style.setProperty('--nm-r07-y',e.clientY+'px');html.style.setProperty('--nm-r07-energy','.22');var target=e.target&&e.target.closest?e.target.closest('a,button,summary,[data-fnxr07-reactive],[data-r07-related-card],.product-grid-item,.grid__item,.fnx-c02-card,.r07-related__card'):null;if(target){target.classList.add('nm-r07-local-light');var r=target.getBoundingClientRect();target.style.setProperty('--nm-local-x',(e.clientX-r.left)+'px');target.style.setProperty('--nm-local-y',(e.clientY-r.top)+'px');}});},{passive:true});
    window.addEventListener('scroll',function(){html.style.setProperty('--nm-r07-energy','.28');clearTimeout(scrollTimer);scrollTimer=setTimeout(function(){html.style.setProperty('--nm-r07-energy','.18');},180);},{passive:true});
    document.addEventListener('pointerleave',function(){html.style.setProperty('--nm-r07-energy','.12');});
    document.addEventListener('pointerenter',function(){html.style.setProperty('--nm-r07-energy','.18');});
  });
})();
;

/* FÉNIX 2.4 V23 HOME HEAD 03 · nm-fenix-r07-search-v24.js */
/* FÉNIX 2.1 — R07 v24 search authority */
(function(){'use strict';var panel=document.getElementById('nmSearchPanel'),triggers=[].slice.call(document.querySelectorAll('.nm-search-toggle,.nm-mobile-search-toggle,[data-nm-search-trigger]'));if(!triggers.length)return;if(!panel){triggers.forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();if(e.stopImmediatePropagation)e.stopImmediatePropagation();location.assign('/search')},true)});return}var body=document.body,header=document.querySelector('.site-header'),form=panel.querySelector('form'),input=panel.querySelector('input[type="search"],input[name="q"]'),results=panel.querySelector('#nmSearchResults'),active=null,isOpen=false,timer=0,controller=null,shell=panel.querySelector('.wrapper')||panel;shell.classList.add('nm-search-v24__shell');if(input)input.classList.add('nm-search-v24__input');if(results)results.classList.add('nm-search-v24__results');panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');panel.setAttribute('aria-label','Buscar productos');panel.setAttribute('aria-hidden','true');var top=document.createElement('div');top.className='nm-search-v24__topbar';var copy=document.createElement('span'),small=document.createElement('small'),strong=document.createElement('strong');small.textContent='BÚSQUEDA NM';strong.textContent='Encuentra tu siguiente opción.';copy.appendChild(small);copy.appendChild(strong);var close=document.createElement('button');close.type='button';close.className='nm-search-v24__close';close.setAttribute('aria-label','Cerrar búsqueda');close.textContent='×';top.appendChild(copy);top.appendChild(close);shell.insertBefore(top,shell.firstChild);var backdrop=document.createElement('button');backdrop.type='button';backdrop.className='nm-search-v24__backdrop';backdrop.setAttribute('aria-label','Cerrar búsqueda');backdrop.hidden=true;body.appendChild(backdrop);function syncTop(){if(header)document.documentElement.style.setProperty('--nm-search-top',Math.max(0,Math.round(header.getBoundingClientRect().bottom))+'px')}function expanded(v){triggers.forEach(function(b){b.setAttribute('aria-controls','nmSearchPanel');b.setAttribute('aria-expanded',v?'true':'false')})}function open(b){active=b||active;syncTop();isOpen=true;panel.hidden=false;backdrop.hidden=false;panel.setAttribute('aria-hidden','false');body.classList.add('nm-search-open-v24');expanded(true);requestAnimationFrame(function(){panel.classList.add('is-open');backdrop.classList.add('is-open');if(input)input.focus({preventScroll:true})})}function shut(focus){if(!isOpen)return;isOpen=false;panel.classList.remove('is-open');backdrop.classList.remove('is-open');panel.setAttribute('aria-hidden','true');body.classList.remove('nm-search-open-v24');expanded(false);setTimeout(function(){if(!isOpen){panel.hidden=true;backdrop.hidden=true}},210);if(focus!==false&&active)active.focus({preventScroll:true})}triggers.forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();if(e.stopImmediatePropagation)e.stopImmediatePropagation();isOpen?shut(true):open(b)},true)});close.addEventListener('click',function(){shut(true)});backdrop.addEventListener('click',function(){shut(true)});document.addEventListener('keydown',function(e){if(isOpen&&e.key==='Escape'){e.preventDefault();shut(true)}});window.addEventListener('resize',function(){if(isOpen)syncTop()},{passive:true});if(form)form.addEventListener('submit',function(e){if(!input||!input.value.trim()){e.preventDefault();if(input)input.focus()}});function empty(text){if(!results)return;results.textContent='';var p=document.createElement('p');p.className='nm-search-v24__empty';p.textContent=text;results.appendChild(p)}function imageOf(p){if(typeof p.image==='string')return p.image;if(p.image&&p.image.url)return p.image.url;if(typeof p.featured_image==='string')return p.featured_image;if(p.featured_image&&p.featured_image.url)return p.featured_image.url;return''}function render(list,q){if(!results)return;results.textContent='';if(!list.length){empty('Presiona Enter para buscar “'+q+'”.');return}var rail=document.createElement('div');rail.className='nm-search-v24__rail';list.slice(0,6).forEach(function(p){var a=document.createElement('a');a.className='nm-search-v24__result';a.href=p.url||('/search?type=product&q='+encodeURIComponent(q));var v=document.createElement('span');v.className='nm-search-v24__visual';var src=imageOf(p);if(src){var img=document.createElement('img');img.src=src;img.alt='';img.loading='lazy';v.appendChild(img)}var c=document.createElement('span');c.className='nm-search-v24__copy';var s=document.createElement('small');s.textContent=p.vendor||'Nootrópicos México';var t=document.createElement('strong');t.textContent=p.title||'Producto';c.appendChild(s);c.appendChild(t);var i=document.createElement('i');i.textContent='→';i.setAttribute('aria-hidden','true');a.appendChild(v);a.appendChild(c);a.appendChild(i);rail.appendChild(a)});results.appendChild(rail);var all=document.createElement('a');all.className='nm-search-v24__all';all.href='/search?type=product&q='+encodeURIComponent(q);all.textContent='Ver todos los resultados para “'+q+'” →';results.appendChild(all)}function suggest(q){if(!results||q.length<2){if(results)results.textContent='';return}if(controller)controller.abort();controller=typeof AbortController!=='undefined'?new AbortController():null;fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide',{credentials:'same-origin',signal:controller?controller.signal:void 0}).then(function(r){if(!r.ok)throw Error();return r.json()}).then(function(d){var list=d&&d.resources&&d.resources.results&&d.resources.results.products||[];render(list,q)}).catch(function(e){if(e.name!=='AbortError')empty('Presiona Enter para buscar “'+q+'”.')})}if(input)input.addEventListener('input',function(){clearTimeout(timer);var q=input.value.trim();timer=setTimeout(function(){suggest(q)},180)});expanded(false);syncTop()})();
;

/* FÉNIX 2.4 V23 HOME HEAD 04 · nm-fenix-r07-fenix-active-guard-v27.js */
/* FÉNIX 2.1 — R07 v27 active-product legacy guard. */
(()=>{const activate=()=>{const root=document.querySelector('[data-fnxr07-noopept],[data-fnxr07-product],[data-fnxr07-family]');if(!root)return;document.body.classList.add('fnx-r07-active');document.querySelectorAll('.nmps,[data-fnx-legacy-description],.nm-product-description-legacy').forEach(el=>{if(!el.closest('[data-fnxr07-noopept],[data-fnxr07-product],[data-fnxr07-family]')){el.hidden=true;el.setAttribute('aria-hidden','true')}});document.querySelectorAll('.nm-pdp-hero-copy__kicker,.nm-pdp-hero-copy__headline').forEach(el=>{el.hidden=true;el.setAttribute('aria-hidden','true')})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',activate,{once:true});else activate()})();
;

/* FÉNIX 2.4 V23 HOME HEAD 05 · nm-fenix-r07-footer-v31.js */
/* FÉNIX 2.1 — R07 v70 · footer copy + single theme authority */
(function(){
  'use strict';

  function initFooterV31(){
    var footer=document.querySelector('footer.site-footer');
    if(!footer)return;
    footer.classList.add('nm-footer-v31');
    var news=footer.querySelector('.nm-footer-newsletter');
    if(!news)return;
    var kicker=news.querySelector('.nm-footer-kicker');
    if(kicker)kicker.textContent='NOVEDADES · OFERTAS';
    var title=news.querySelector('h4');
    if(title)title.textContent='Novedades y ofertas';
    var directParagraph=null;
    for(var i=0;i<news.children.length;i++){
      if(news.children[i].tagName==='P'){
        directParagraph=news.children[i];
        break;
      }
    }
    if(directParagraph){
      directParagraph.textContent='Recibe novedades, lanzamientos, guías y ofertas seleccionadas directamente en tu correo.';
    }
    var buttonText=news.querySelector('.nm-newsletter-form__submit span');
    if(buttonText)buttonText.textContent='Suscribirme';
  }

  function initThemeAuthorityV70(){
    if(window.__NM_THEME_AUTHORITY_V70__)return;
    window.__NM_THEME_AUTHORITY_V70__=true;

    var root=document.documentElement;
    var storageKey='nmTheme';

    function normalize(value){
      return value==='light'?'light':'dark';
    }

    function readSaved(){
      try{return localStorage.getItem(storageKey);}catch(e){return null;}
    }

    function currentTheme(){
      return normalize(root.getAttribute('data-nm-theme')||root.getAttribute('data-theme')||readSaved());
    }

    function syncControls(theme){
      var next=theme==='light'?'oscuro':'claro';
      var controls=document.querySelectorAll('.nm-theme-toggle');
      for(var i=0;i<controls.length;i++){
        controls[i].setAttribute('title','Cambiar a '+next);
        controls[i].setAttribute('aria-label','Cambiar a '+next);
        controls[i].setAttribute('aria-pressed',theme==='light'?'true':'false');
        controls[i].setAttribute('data-nm-theme-current',theme);
      }
    }

    function applyTheme(theme,persist){
      theme=normalize(theme);
      root.setAttribute('data-nm-theme',theme);
      root.setAttribute('data-theme',theme);
      root.setAttribute('data-nm-theme-authority','v70');
      root.classList.toggle('nm-theme-light',theme==='light');
      root.classList.toggle('nm-theme-dark',theme==='dark');
      root.style.colorScheme=theme;

      if(document.body){
        document.body.classList.toggle('nm-theme-light',theme==='light');
        document.body.classList.toggle('nm-theme-dark',theme==='dark');
      }

      if(persist){
        try{localStorage.setItem(storageKey,theme);}catch(e){}
      }

      syncControls(theme);

      try{
        window.dispatchEvent(new CustomEvent('nm:themechange',{detail:{theme:theme,authority:'v70'}}));
      }catch(e){}
    }

    function toggleTheme(){
      applyTheme(currentTheme()==='light'?'dark':'light',true);
    }

    document.addEventListener('click',function(event){
      var target=event.target;
      if(!target||!target.closest)return;
      var button=target.closest('.nm-theme-toggle');
      if(!button)return;
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleTheme();
    },true);

    var initial=readSaved();
    if(initial!=='light'&&initial!=='dark')initial=currentTheme();
    applyTheme(initial,false);

    window.addEventListener('pageshow',function(){
      var saved=readSaved();
      applyTheme(saved==='light'||saved==='dark'?saved:currentTheme(),false);
    });

    if('MutationObserver' in window){
      var observer=new MutationObserver(function(mutations){
        var needsSync=false;
        for(var i=0;i<mutations.length&&!needsSync;i++){
          if(mutations[i].addedNodes&&mutations[i].addedNodes.length)needsSync=true;
        }
        if(needsSync)syncControls(currentTheme());
      });
      observer.observe(document.documentElement,{childList:true,subtree:true});
    }

    window.NMTheme={
      get:currentTheme,
      set:function(theme){applyTheme(theme,true);},
      toggle:toggleTheme
    };
  }

  function init(){
    initFooterV31();
    initThemeAuthorityV70();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }
})();
;

/* FÉNIX 2.4 V23 HOME HEAD 06 · nm-fenix-r07-preview-cleanup.js */
/* FÉNIX R07.63 · preview cleanup: retira únicamente marcas de laboratorio. */
(function(){
  'use strict';

  function cleanupLabMarker(){
    var badge=document.getElementById('fnx-lab-build');
    if(badge) badge.remove();
    document.title=document.title.replace(/^\[H02\]\s*/,'');
  }

  function scheduleCleanup(){
    setTimeout(cleanupLabMarker,0);
    setTimeout(cleanupLabMarker,40);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',scheduleCleanup,{once:true});
  }else{
    scheduleCleanup();
  }
  window.addEventListener('load',scheduleCleanup,{once:true});

  if('MutationObserver' in window){
    new MutationObserver(function(){
      var badge=document.getElementById('fnx-lab-build');
      if(badge) badge.remove();
    }).observe(document.documentElement,{childList:true,subtree:true});
  }
})();
;
